import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createPinia, setActivePinia } from 'pinia';

import App from "./App";
import "./index.css";
import "aos/dist/aos.css";
import AOS from 'aos';
import "./i18n"; // si tu utilises l'internationalisation
import { store } from "./redux/stores/store";

const pinia = createPinia();
setActivePinia(pinia);

// Créer un contexte pour Pinia
export const PiniaContext = React.createContext(pinia);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PiniaContext.Provider value={pinia}>
      <Provider store={store}>
        <App />
      </Provider>
    </PiniaContext.Provider>
  </React.StrictMode>
);

// Initialize AOS animations after app mount
AOS.init({
  duration: 600,
  easing: 'ease-out-cubic',
  once: true,
});
